document.addEventListener('alpine:init', () => {
  Alpine.store('cartCount', {
    count: (window.theme && window.theme.cartItemCount) || 0,
    init() {
      window.addEventListener('baseline:cart:afteradditem', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });

      window.addEventListener('baseline:cart:cartqtychange', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });

      window.addEventListener('baseline:cart:update', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });
    },
    _setFromFetchedSection(data) {
      const countSectionHTML = data.sections['cart-item-count'];

      this.count = parseInt(
        parseDOMFromString(countSectionHTML).firstElementChild.innerText.trim(),
        10
      );

      window.theme.cartItemCount = this.count;

      document.querySelectorAll('.custom-var').forEach(function (customVar) {
  customVar.addEventListener('click', function (e) {
    const cartPdtVariantWrapper = customVar.closest('.cart-pdt-variant-wrapper');

    if (cartPdtVariantWrapper.classList.contains('loading')) {
      console.warn('Action already in progress for this variant.');
      return;
    }

    cartPdtVariantWrapper.classList.add('loading');

    const currentId = cartPdtVariantWrapper.getAttribute('data-id');
    const changeVarId = customVar.getAttribute('data-id');
    const itemCurrentQty = customVar
      .closest('.cart-item')
      .querySelector('.cart-qnty').value;

    if (!currentId || !changeVarId || !itemCurrentQty) {
      console.error('Missing required data for the request.');
      cartPdtVariantWrapper.classList.remove('loading');
      return;
    }

    const formData = new FormData();
    formData.append('id', changeVarId);
    formData.append('quantity', itemCurrentQty);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to add item to cart');
        }
        return response.json();
      })
      .then((data) => {
          removeItem(currentId, 0);
      })
      .catch((error) => {
        console.error('Error in AJAX request:', error);
      })
      .finally(() => {
        cartPdtVariantWrapper.classList.remove('loading');
      });
  });
});

function removeItem(data_line, qty) {
  const url = '/cart/change.js';
  const params = new URLSearchParams();
  params.append('quantity', qty);
  params.append('id', data_line);

  fetch(url, {
    method: 'POST',
    body: params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to remove item from cart');
      }
      return response.json();
    })
    .then((data) => {
      if (document.location.href.indexOf('/cart') > -1) {
        window.location.href = '/cart';
      } else {
        console.log('Item removed successfully');
      }
    })
    .catch((error) => {
      console.error('Error in removing item:', error);
    });
}


function removeActiveClassFromAll() {
  document.querySelectorAll('.cart-pdt-variant-wrapper').forEach(function (el) {
    el.classList.remove('active');
  });
}

document.querySelectorAll('.cart-pdt-variant-wrapper').forEach(function (element) {
  element.addEventListener('click', function () {
    if (this.classList.contains('active')) {
      this.classList.remove('active');
    } else {
      removeActiveClassFromAll();
      this.classList.add('active');
    }
  });
});


document.querySelectorAll('.cart-pdt-variant-wrapper').forEach(function(wrapper) {
    wrapper.addEventListener('click', function(event) {
        if (event.target && event.target.classList.contains('var')) {
            removeActiveClassFromAll();

            var variantText = event.target.textContent.trim();
            var variantId = event.target.getAttribute('data-id');

            wrapper.querySelector('.cart-pdt-variant').textContent = variantText;

            wrapper.setAttribute('data-id', variantId);

            wrapper.classList.remove("active");
        }
    });
});

      
    },
    countWithText() {
      return this.count;
      
    },
  });
});
